import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionService } from '@unity/services/permission.service';
import { SessionService } from '@unity/services/session.service';
import { UnityEntitlementPath } from '@unity/utils/types';

@Directive({
  selector: '[unityAuthorizeForInternal]',
  standalone: true,
})
export class AuthorizeForInternalDirective {
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef);
  private readonly sessionService = inject(SessionService);
  private readonly permissionService = inject(PermissionService);

  private readonly $permissions = this.permissionService.$currentPermissions;
  private readonly $isInternal = this.sessionService.$isInternalUserRole;

  public readonly $unityAuthorizeForInternal = input.required<UnityEntitlementPath>({ alias: 'unityAuthorizeForInternal' });
  public readonly $unityAuthorizeForInternalElse = input<TemplateRef<unknown>>(undefined, { alias: 'unityAuthorizeForInternalElse' });

  public constructor() {
    effect(() => {
      const authorizeClaim = this.$unityAuthorizeForInternal();
      const elseRef = this.$unityAuthorizeForInternalElse();
      const permissions = this.$permissions();
      const isInternal = this.$isInternal();

      const isEntitled = isInternal && permissions?.includes(authorizeClaim);
      const template = isEntitled ? this.templateRef : elseRef;

      this.viewContainerRef.clear();
      if (template) {
        this.viewContainerRef.createEmbeddedView(template);
      }
    });
  }
}
